import type { Store } from 'vuex'
import * as yup from 'yup'

import type { RootState } from '@/store/index'
import { ListNgWordsResponse } from '@/types/ngWord'

// NGワードバリデーション関数を生成
export const createNgWordValidateFunction = (
  ngWords: string[]
): yup.TestFunction<string | undefined, yup.AnyObject> => {
  return (value: string | undefined) => {
    if (value === undefined) {
      return true
    }

    // 文字列にNGワードが含まれていないか
    // 見つからなかったときは undefined
    const found = ngWords.find((ngWord) => value.indexOf(ngWord) !== -1)

    return found === undefined
  }
}

export const getNgWords = async (target: number, store: Store<RootState>) => {
  const ngWordsResponse = (await store.dispatch('listNgWords', { target: target })) as ListNgWordsResponse

  return ngWordsResponse.data.ngWords
}
